export const when = (name: string) => (val: any, whenNot: any = '') => (
  obj: any
) => (obj[name] ? val : whenNot)

export const whenNot = (name: string) => (val: any) => (obj: any) =>
  !obj[name] && val



// WEBPACK FOOTER //
// ./src/utils/mixin.ts